import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import COMPARAI from 'constants/comparai';

const PartnerMessage = ({ ...props }) => (
  <Flex justifyContent="flex-end" alignItems="center" full {...props}>
    <Text mr={2}>{COMPARAI.PARTNER_PROMOBIT}</Text>
    <Icon name="info-sign" />
  </Flex>
);
export default PartnerMessage;
